import { useMemo } from 'react'
import { CancelPolicySummary } from '~/__generated__/__types__'

// 주문 아이템 대해 취소규정과 관련된 data 를 return 한다.
const useCancelCommission = cancelPolicySummary => {
  const cancelSummary = useMemo<CancelPolicySummary | undefined>(() => {
    // cancelPolicySummary 가 undefined 인 경우 취소 정책 fetch fail 이 발생한 경우이다.
    if (!cancelPolicySummary) {
      return
    }

    // FES-1071 취소가 가능한 경우 nonCancellationReason = null 로써, 해당 경우에만 취소규정을 노출한다.
    if (
      cancelPolicySummary.nonCancellationReason === null ||
      cancelPolicySummary.nonCancellationReason === 'NON_REFUNDABLE'
    ) {
      return cancelPolicySummary
    } else {
      return {
        cancelable: false,
        nonCancellationReason: 'UNAVAILABLE',
      }
    }
  }, [cancelPolicySummary])

  return {
    cancelSummary,
  }
}

export default useCancelCommission
